module.exports = __webpack_public_path__ + "public/img/addTeam.b6d03211.png";